import React, { useState } from "react";

import axios from "axios";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";
//styled
export default function PinPostModal({ post, cancelModal, fetchData }) {
  const { user } = useAuthContext();
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handlePinPost = async () => {
    setIsLoading(true);
    try {
      const pinResponse = await axios.post(
        `${ApiConnectionString}/api/ClubPost/pin/${post.id}`,
        null,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
  
      if (pinResponse.status === 200) {
       
        setComplete(true); // Indicate the operation was successful
      }
    } catch (error) {
      console.error("Error pinning post:", error);
      // Optionally handle the error, e.g., show a message to the user
    } finally {
      setIsLoading(false); // Ensure the loading state is stopped
    }
  };
  

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
        </div>
      </div>
    );
  } else {
    if (complete) {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Pin This Post</p>
            </div>

            <p>The post has been successfully pinned.</p>

            <div className="send-modal-footer">
              <button
                onClick={() => { fetchData(); cancelModal();}}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="send-modal-overlay">
          <div className="send-modal">
            <div className="blueBanner">
              <p className="fw-bold m-2 p-2 fontSize20">Pin This Post</p>
            </div>

            <button
              type="button"
              className="close-button"
              onClick={cancelModal}
              aria-label="Close"
            >
              &times;
            </button>

            <div>
              <strong className="red-text">{post.title}</strong>
              <p className="text-muted">{post.createdDate.substring(0, 10)}</p>
              <p>{post.content}</p>
            </div>
            <p>Are you sure you want to pin this post?</p>

            <div className="send-modal-footer">
              <button className="saveChanges-button" onClick={handlePinPost}>
                Confirm
              </button>

              <button
                onClick={cancelModal}
                className="pointer cancelButton fw-bold mx-2 px-3"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}
